// @flow

import { type CheckoutReceipts } from './types';

export const ONE_INSTALMENT: CheckoutReceipts = {
  main: {
    fx: {
      from: 'USD',
      to: 'BRL',
      rate: '4.1700',
    },
    amount_ext: [ 'USD', '100.00' ],
    amount_local_base: [ 'BRL', '417.00' ],
    amount_local_total: [ 'BRL', '418.58' ],
    local_taxes: [
      {
        code: 'BR_IOF',
        amount: [ 'BRL', '1.58' ],
        rate: '0.0038',
      },
    ],
  },
  instalments_strategy: 'from-invoice',
  instalments: {
    [1]: {
      fx: {
        from: 'USD',
        to: 'BRL',
        rate: '4.1700',
      },
      amount_ext: [ 'USD', '100.00' ],
      amount_local_base: [ 'BRL', '417.00' ],
      amount_local_total: [ 'BRL', '418.58' ],
      local_taxes: [
        {
          code: 'BR_IOF',
          amount: [ 'BRL', '1.58' ],
          rate: '0.0038',
        },
      ],
      instalments_plan: {
        instalments: 1,
        amount_partial_first: [ 'BRL', '418.58' ],
        amount_partial_other: [ 'BRL', '418.58' ],
      },
    },
  },
};

export const TWO_INSTALMENTS: CheckoutReceipts = {
  main: {
    fx: {
      from: 'USD',
      to: 'BRL',
      rate: '4.1700',
    },
    amount_ext: [ 'USD', '100.00' ],
    amount_local_base: [ 'BRL', '417.00' ],
    amount_local_total: [ 'BRL', '418.58' ],
    local_taxes: [
      {
        code: 'BR_IOF',
        amount: [ 'BRL', '1.58' ],
        rate: '0.0038',
      },
    ],
  },
  instalments_strategy: 'from-invoice',
  instalments: {
    [1]: {
      fx: {
        from: 'USD',
        to: 'BRL',
        rate: '4.1700',
      },
      amount_ext: [ 'USD', '100.00' ],
      amount_local_base: [ 'BRL', '417.00' ],
      amount_local_total: [ 'BRL', '418.58' ],
      local_taxes: [
        {
          code: 'BR_IOF',
          amount: [ 'BRL', '1.58' ],
          rate: '0.0038',
        },
      ],
      instalments_plan: {
        instalments: 1,
        amount_partial_first: [ 'BRL', '418.58' ],
        amount_partial_other: [ 'BRL', '418.58' ],
      },
    },
    [2]: {
      fx: {
        from: 'USD',
        to: 'BRL',
        rate: '4.1700',
      },
      amount_ext: [ 'USD', '100.00' ],
      amount_local_base: [ 'BRL', '417.00' ],
      amount_local_total: [ 'BRL', '418.58' ],
      local_taxes: [
        {
          code: 'BR_IOF',
          amount: [ 'BRL', '1.58' ],
          rate: '0.0038',
        },
      ],
      instalments_plan: {
        instalments: 2,
        amount_partial_first: [ 'BRL', '209.29' ],
        amount_partial_other: [ 'BRL', '209.29' ],
      },
    },
  },
};

export const TWO_INSTALMENTS_WITH_FEES: CheckoutReceipts = {
  main: {
    fx: {
      from: 'USD',
      to: 'BRL',
      rate: '4.1700',
    },
    amount_ext: [ 'USD', '100.00' ],
    amount_local_base: [ 'BRL', '417.00' ],
    amount_local_total: [ 'BRL', '418.58' ],
    local_taxes: [
      {
        code: 'BR_IOF',
        amount: [ 'BRL', '1.58' ],
        rate: '0.0038',
      },
    ],
  },
  instalments_strategy: 'from-invoice',
  instalments: {
    [1]: {
      fx: {
        from: 'USD',
        to: 'BRL',
        rate: '4.1700',
      },
      amount_ext: [ 'USD', '100.00' ],
      amount_local_base: [ 'BRL', '417.00' ],
      amount_local_total: [ 'BRL', '418.58' ],
      local_taxes: [
        {
          code: 'BR_IOF',
          amount: [ 'BRL', '1.58' ],
          rate: '0.0038',
        },
      ],
      instalments_plan: {
        instalments: 1,
        amount_partial_first: [ 'BRL', '418.58' ],
        amount_partial_other: [ 'BRL', '418.58' ],
      },
    },
    [2]: {
      fx: {
        from: 'USD',
        to: 'BRL',
        rate: '4.1700',
      },
      amount_ext: [ 'USD', '100.00' ],
      amount_local_base: [ 'BRL', '417.00' ],
      amount_local_total: [ 'BRL', '428.58' ],
      local_taxes: [
        {
          code: 'BR_IOF',
          amount: [ 'BRL', '1.58' ],
          rate: '0.0038',
        },
      ],
      instalments_plan: {
        instalments: 2,
        amount_partial_first: [ 'BRL', '214.29' ],
        amount_partial_other: [ 'BRL', '214.29' ],
      },
    },
  },
};

export const DEBIN_INSTALMENT_FEE_BY_CUSTOMER: CheckoutReceipts = {
  main: {
    fx: {
      from: 'USD',
      to: 'BRL',
      rate: '4.1700',
    },
    amount_ext: [ 'USD', '100.00' ],
    amount_local_base: [ 'BRL', '417.00' ],
    amount_local_total: [ 'BRL', '418.58' ],
    local_taxes: [
      {
        code: 'BR_IOF',
        amount: [ 'BRL', '1.58' ],
        rate: '0.0038',
      },
    ],
  },
  instalments_strategy: 'from-invoice',
  instalments: {
    [1]: {
      fx: {
        from: 'USD',
        to: 'BRL',
        rate: '4.1700',
      },
      amount_ext: [ 'USD', '100.00' ],
      amount_local_base: [ 'BRL', '417.00' ],
      amount_local_total: [ 'BRL', '418.58' ],
      local_taxes: [
        {
          code: 'BR_IOF',
          amount: [ 'BRL', '1.58' ],
          rate: '0.0038',
        },
      ],
      instalments_plan: {
        instalments: 1,
        amount_partial_first: [ 'BRL', '418.58' ],
        amount_partial_other: [ 'BRL', '418.58' ],
      },
    },
  },
  instalments_with_end_user_fee: {
    banktransfer: {
      debin: {
        [1]: {
          transaction_fees: [
            {
              code: 'INSTALLMENT_FEE',
              amount: ['ARS', '29.00'],
              percent_value: '3.99',
            },
          ],
          fx: {
            from: 'ARS',
            to: 'ARS',
            rate: '1.0000',
          },
          amount_ext: ['ARS', '100.00'],
          amount_local_base: ['ARS', '129.00'],
          amount_local_total: ['ARS', '152.00'],
          local_taxes: [
            { code: 'AR_IG_IBP', amount: ['ARS', '0.00'], rate: '0.0000' },
            { code: 'AR_NON_RESIDENT_IGBP', amount: ['ARS', '1.00'], rate: '0.0100' },
            { code: 'AR_IIBB_DF', amount: ['ARS', '2.00'], rate: '0.0200' },
            { code: 'AR_IVA', amount: ['ARS', '21.00'], rate: '0.2100' },
            { code: 'INSTALLMENT_FEE', amount: ['ARS', '21.00'], rate: '0.2100' },
          ],
          installments_plan_token: 'fee-q3asdjahsdkja',
          instalments_plan: {
            instalments: 1,
            amount_partial_first: ['ARS', '152.00'],
            amount_partial_other: ['ARS', '152.00'],
          },
        },
      },
    },
  },
};
